export const REQUEST_USER_DATA = 'REQUEST_USER_DATA'
export const RECEIVE_USER_DATA = 'RECEIVE_USER_DATA'
export const RECEIVE_USER_DATA_FAILURE = 'RECEIVE_USER_DATA_FAILURE'

function requestUserData() {
  return { type: REQUEST_USER_DATA }
}

function receiveUserData(data) {
  return { type: RECEIVE_USER_DATA, data: data }
}

function receiveUserDataFailure(error) {
  return { type: RECEIVE_USER_DATA_FAILURE, error: error.message }
}

export function fetchUserData() {
  return dispatch => {
    dispatch(requestUserData())
    return fetch('/profiles?filter[relation]=me', { credentials: 'include', redirect: 'follow' })
      .then(response => {
        if(response.ok) {
          return response.json()
        } else {
          throw new Error(response.body || response.statusText)
        }
      })
      .then(json => {
        dispatch(receiveUserData((json.data[0] || {}).attributes))
      })
      .catch(error => dispatch(receiveUserDataFailure(error.message)))
  }
}
